// extracted by mini-css-extract-plugin
module.exports = {"picture":"LazyImage_picture__Bw4VB","image":"LazyImage_image__StCXb","placeholder":"LazyImage_placeholder__Y6n_c"};